// extracted by mini-css-extract-plugin
export var headerCell = "_1b-1";
export var loadingSpinnerContainer = "_1b-4";
export var loadingStateCell = "_1b-5";
export var rowWrapper = "_1b-3";
export var standaloneTable = "_1b-6";
export var table = "_1b-0";
export var white = "_1b-2";